import { formatCurrencyValues } from "../../utils/convertUtils";

const mapCard = (json) => {
    const {
        Taxonomy,
        SumBalDebit,
        SumBalCredit,
        Debit,
        Credit,
        AccDebit,
        AccCredit,
        CurrencyOptions,
        DebitCreditIndicator,
    } = json;

    return [
        [{ labels: ["Taxonomy"], value: Taxonomy, type: "string" }],
        [
            {
                labels: ["DebitCreditIndicator"],
                value: DebitCreditIndicator,
                type: "string",
                align: "center",
            },
        ],
        [
            {
                labels: ["Debit"],
                value: formatCurrencyValues(CurrencyOptions, Debit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["Credit"],
                value: formatCurrencyValues(CurrencyOptions, Credit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalDebit"],
                value: formatCurrencyValues(CurrencyOptions, AccDebit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalDebit"],
                value: formatCurrencyValues(CurrencyOptions, AccCredit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalDebit"],
                value: formatCurrencyValues(CurrencyOptions, SumBalDebit),
                type: "currency",
            },
        ],
        [
            {
                labels: ["SumBalCredit"],
                value: formatCurrencyValues(CurrencyOptions, SumBalCredit),
                type: "currency",
            },
        ],
    ];
};

const header = [
    { label: ["Taxonomy"], align: "left" },
    { label: ["Debit Credit Indicator"], align: "center" },
    { label: ["Period Debit"], align: "right" },
    { label: ["Period Credit"], align: "right" },
    { label: ["Accumulated Debit"], align: "right" },
    { label: ["Accumulated Credit"], align: "right" },
    { label: ["Debit Balance"], align: "right" },
    { label: ["Credit Balance"], align: "right" },
];

const mapper = (json, card) => {
    const { TaxonomyCode, DebitCreditIndicator } = json;
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
        link: {
            to: "/:locale(pt|en|lt|es|ro|fr)?/:projectId/:fiscalYear([0-9]{4}|current)/:importId/:modulePrefix/reports/nc_trial_balance",
            appendFilters: ["CLB_Period"],
            filter: [
                { filters: [{ value: TaxonomyCode }], column: "TaxonomyCode" },
                {
                    filters: [
                        {
                            value: DebitCreditIndicator,
                        },
                    ],
                    column: "DebitCreditIndicator"
                },
            ],
        },
    };
};

const nctrialbalancetaxonomyMapper = {
    map: mapper,
    header,
};

export default nctrialbalancetaxonomyMapper;
